// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend"; // Added HTTP backend for lazy loading

// Importez vos fichiers de traduction (JSON)
import translationZH from "./locales/zh/translation.json";
import translationEN from "./locales/en/translation.json";
import translationFR from "./locales/fr/translation.json";
import translationDE from "./locales/de/translation.json";
import translationES from "./locales/es/translation.json";
import translationHI from "./locales/hi/translation.json";
import translationJA from "./locales/ja/translation.json";
//Location
import locationZH from "./locales/zh/location.json";
import locationEN from "./locales/en/location.json";
import locationFR from "./locales/fr/location.json";
import locationDE from "./locales/de/location.json";
import locationES from "./locales/es/location.json";
import locationHI from "./locales/hi/location.json";
import locationJA from "./locales/ja/location.json";
//functions
import functionZH from "./locales/zh/function.json";
import functionEN from "./locales/en/function.json";
import functionFR from "./locales/fr/function.json";
import functionDE from "./locales/de/function.json";
import functionES from "./locales/es/function.json";
import functionHI from "./locales/hi/function.json";
import functionJA from "./locales/ja/function.json";
//seniority
import seniorityZH from "./locales/zh/seniority.json";
import seniorityEN from "./locales/en/seniority.json";
import seniorityFR from "./locales/fr/seniority.json";
import seniorityDE from "./locales/de/seniority.json";
import seniorityES from "./locales/es/seniority.json";
import seniorityHI from "./locales/hi/seniority.json";
import seniorityJA from "./locales/ja/seniority.json";
//workSetUp
import workSetUpZH from "./locales/zh/workSetUp.json";
import workSetUpEN from "./locales/en/workSetUp.json";
import workSetUpFR from "./locales/fr/workSetUp.json";
import workSetUpDE from "./locales/de/workSetUp.json";
import workSetUpES from "./locales/es/workSetUp.json";
import workSetUpHI from "./locales/hi/workSetUp.json";
import workSetUpJA from "./locales/ja/workSetUp.json";

i18n
  .use(HttpBackend) // Use HTTP backend to load translation files on demand
  .use(LanguageDetector) // Automatically detects the user's language
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEN,
        location: locationEN,
        function: functionEN,
        seniority: seniorityEN,
        workSetUp: workSetUpEN,
      },
      fr: {
        translation: translationFR,
        location: locationFR,
        function: functionFR,
        seniority: seniorityFR,
        workSetUp: workSetUpFR,
      },
      zh: {
        translation: translationZH,
        location: locationZH,
        function: functionZH,
        seniority: seniorityZH,
        workSetUp: workSetUpZH,
      }, // Adding Chinese resources
      de: {
        translation: translationDE,
        location: locationDE,
        function: functionDE,
        seniority: seniorityDE,
        workSetUp: workSetUpDE,
      },
      es: {
        translation: translationES,
        location: locationES,
        function: functionES,
        seniority: seniorityES,
        workSetUp: workSetUpES,
      },
      hi: {
        translation: translationHI,
        location: locationHI,
        function: functionHI,
        seniority: seniorityHI,
        workSetUp: workSetUpHI,
      },
      ja: {
        translation: translationJA,
        location: locationJA,
        function: functionJA,
        seniority: seniorityJA,
        workSetUp: workSetUpJA,
      },
    },
    lng: navigator.language.slice(0, 2), // Simplifies detected language to the first two characters
    fallbackLng: "en", // Default language if the detected language is not available
    interpolation: {
      escapeValue: false, // React automatically escapes values
    },
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["cookie"], // Caches the selected language for future visits
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // Path to translation JSON files
    },
    ns: ["translation", "location", "function", "seniority", "workSetUp"],
    defaultNS: "translation", // Set default namespace
    load: "languageOnly", // Loads only the first two letters of the language code
    react: {
      useSuspense: true, // Uses Suspense for handling asynchronous loading
    },
  });

export default i18n;
